<template>
  <div class="base-upload">
    <el-upload
      :action="listObj.uploadURl"
      list-type="picture-card"
      :show-file-list="true"
      :file-list="fileList"
      :class="{certIsHide: listObj.hide==true}"
      :disabled="disabled"
      :with-credentials="true"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-error="handleError">
      <!-- <img v-if="uploadList.idCardFront" :src="uploadList.idCardFront" class="avatar"> -->
      <i class="el-icon-plus avatar-uploader-icon">
        <h4 class="upload-tip" :class="{certIsHide: listObj.hide==true}">{{listObj.tip}}</h4>
      </i>
    </el-upload>
    <p class="desc" >{{listObj.desc}}</p>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
export default {
  props: {
    listObj: {
      type: Object,
      require: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hide: false
    };
  },
  computed: {
    fileList() {
      if (this.listObj.url) {
        this.$set(this.listObj, "hide", true);
        return [{ url: this.listObj.url }];
      }
    }
  },
  mounted() {
    // if (this.listObj.url) {
    //   this.listObj.hide = true;
    // }
  },
  methods: {
    // 图片上传之前
    beforeUpload(file) {
      this.listObj.hide = true;
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$Alert.info({
          content: "上传图片只能是JPG/png格式!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$Alert.info({
          content: "上传图片大小不能超过500kb!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
    },
    //文件上传失败
    handleError(err, file, fileList) {
      this.listObj.hide = false;
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.$emit("transImg", res);
    },
    // 文件移除
    handleRemove(file, fileList) {
      // this.listObj.hide = false;

      this.$emit("removeImg", this.listObj.remark);
      this.$set(this.listObj, "hide", false);
    }
  }
};
</script>
<style lang="stylus">
  .certIsHide
    height:148px;
    width:160px;
    
    >div.el-upload
      display: none !important;
      height: 0px !important;
  .desc
    text-align :center;
    color:#b0b0b0;
  .desc.certIsHide
    display: none !important;
   
</style>

//  this.$set(this.listObj, "hide", true);
